import script from "./MergeTeachersDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./MergeTeachersDialog.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__